import { render, staticRenderFns } from "./kw_back_audio.vue?vue&type=template&id=dc419010&scoped=true&"
import script from "./kw_back_audio.vue?vue&type=script&lang=js&"
export * from "./kw_back_audio.vue?vue&type=script&lang=js&"
import style0 from "./kw_back_audio.vue?vue&type=style&index=0&id=dc419010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc419010",
  null
  
)

component.options.__file = "kw_back_audio.vue"
export default component.exports